import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useAccessToken } from 'utils/auth';
import { createCv, deleteCv, fetchCv, updateCv } from './api';
import { CreateCvRequest } from './api-types';

const TALENT_CV_QUERY_KEY = 'talentCv';

export const useTalentCvQuery = (token: string | undefined) =>
  useQuery([TALENT_CV_QUERY_KEY, token], () => fetchCv(token), {
    enabled: !!token
  });

export const useCreateCvMutation = () => {
  const { token } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation(
    [TALENT_CV_QUERY_KEY, 'create', token],
    (payload: CreateCvRequest) => createCv(token, payload),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries([TALENT_CV_QUERY_KEY]);
      }
    }
  );
};

export const useUpdateCvMutation = () => {
  const { token } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation(
    [TALENT_CV_QUERY_KEY, 'update', token],
    (payload: CreateCvRequest) => updateCv(token, payload),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries([TALENT_CV_QUERY_KEY]);
      }
    }
  );
};

export const useDeleteCvMutation = () => {
  const { token } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation(
    [TALENT_CV_QUERY_KEY, 'delete', token],
    () => deleteCv(token),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries([TALENT_CV_QUERY_KEY]);
      }
    }
  );
};
